module.exports = __webpack_public_path__ + "static/logo-black-278dae3fbd7106186778038d2c12fe90.png";